import {createContext} from 'react'

function noop () {}

export const BaseContext = createContext ({
    base: null,
    selectBase: noop,
    clearBase: noop
})